import { render } from "./JourneyDetailedInfo.vue?vue&type=template&id=d7fb4220&scoped=true&lang=pug"
import script from "./JourneyDetailedInfo.vue?vue&type=script&lang=ts"
export * from "./JourneyDetailedInfo.vue?vue&type=script&lang=ts"

import "./JourneyDetailedInfo.vue?vue&type=style&index=0&id=d7fb4220&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d7fb4220"

export default script